<!-- Compiled at 2026-10-07T06:21:14.844Z -->
<ng-container *ngIf="$isVariablesInitialized()">
	<ng-container *lowgileScope="null; screen: this; let $scope">
		<ng-container *lowgileForm="null; screen: this; let $formDirective">
			<div style="display: contents" [class.fill]="false">
				<Toolbox-MainLayout
					[$formDirective]="$formDirective"
					[$disabled]="$disabled"
					[$ignoreValidations]="$ignoreValidations"
					[screenTitle]="'My team\'s performance development'"
					[isForExternalUser]=""
				>
					<ng-template
						data-content-area="content"
						let-$scope="$scope"
						let-$formDirective="$formDirective"
						let-$disabled="$disabled"
					>
						<ng-container *lowgileScope="null; screen: this; let $scope">
							<div
								data-content-area="content"
								data-defined-in="Toolbox.GoalSettingsMyTeam"
							>
								<Toolbox-GoalSettingsListInclude
									[$formDirective]="$formDirective"
									[$disabled]="$disabled"
									[$ignoreValidations]="$ignoreValidations"
									[additionalFilterOptions]="{
    manager: {
        userId: Sys.User.currentUser.id
    }
}"
								>
								</Toolbox-GoalSettingsListInclude>
							</div>
						</ng-container>
					</ng-template>
				</Toolbox-MainLayout>
			</div>
		</ng-container>
	</ng-container>
</ng-container>
